import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { notifyPromise } from "../../../Utils/Helper";
import { changeUserPasswordSuccess, changeUserPasswordFailure } from "../../Action/auth/changeUserPasswordAction";
import { CHANGE_USER_PASSWORD } from "../../Action/actionTypes";

function* changeUserPasswordRequest(action) {
  try {
 

    const { userId, newPass, adminPass } = action.payload;
    const { data } = yield notifyPromise(API.put(`/update-user-password?id=${userId}`, { newPass, adminPass }));

    if (action?.payload?.callback) {
      yield call(action.payload.callback, data);
    }

    if (data?.meta?.code === 200) {
      yield put(changeUserPasswordSuccess(data?.data));
    } else {
      yield put(changeUserPasswordFailure());
    }
  } catch (error) {
    if (action?.payload?.callback) {
      yield call(action.payload.callback, {});
    }
    yield put(changeUserPasswordFailure());
  }
}

export function* watchChangeUserPassword() {
  yield takeEvery(CHANGE_USER_PASSWORD, changeUserPasswordRequest);
}

export default function* rootSaga() {
  yield all([watchChangeUserPassword()]);
}
